var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 -2 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M611,248.002473 C611,247.448823 611.443717,247 611.999807,247 L615.502301,247 C615.777173,247 616.09954,246.80092 616.221932,246.556135 L616.778068,245.443865 C616.900637,245.198725 617.22788,245 617.491005,245 L622.508995,245 C622.780169,245 623.09954,245.19908 623.221932,245.443865 L623.778068,246.556135 C623.900637,246.801275 624.214844,247 624.497699,247 L628.000193,247 C628.552371,247 629,247.455761 629,248.002473 L629,257.997527 C629,258.551177 628.555054,259 628.006602,259 L611.993398,259 C611.444759,259 611,258.544239 611,257.997527 L611,248.002473 Z M620,257 C622.209139,257 624,255.209139 624,253 C624,250.790861 622.209139,249 620,249 C617.790861,249 616,250.790861 616,253 C616,255.209139 617.790861,257 620,257 Z M620,256 C621.656854,256 623,254.656854 623,253 C623,251.343146 621.656854,250 620,250 C618.343146,250 617,251.343146 617,253 C617,254.656854 618.343146,256 620,256 Z M626,252 C626.552285,252 627,251.552285 627,251 C627,250.447715 626.552285,250 626,250 C625.447715,250 625,250.447715 625,251 C625,251.552285 625.447715,252 626,252 Z M613,246.5 C613,246.223858 613.214035,246 613.504684,246 L614.495316,246 C614.774045,246 615,246.231934 615,246.5 L615,247 L613,247 L613,246.5 Z",
    transform: "translate(-611 -245)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.d97eb2c4de9104acde08aa1645a2b836.svg";
export { ForwardRef as ReactComponent };